import { provideRouter } from '@angular/router';
import { AdminDashboard } from './admin-dashboard/admin-dashboard';
import { Store } from './store/store';
import { StockItemComponent } from './stock-items/stock-items';
import { TransactionsComponent } from './transactions/transactions';
import { PatientsComponent } from './patients/patients';
import { StaffLogsComponent } from './staff-logs/staff-logs';
import { ReportComponent } from './reports/reports';
import { AuthGuard } from './guards/auth-guard';
import { IssueDrugComponent } from './issues-drug/issues-drug';
import { WardComponent } from './wards/wards';
import { PatientDetailsComponent } from './patient-details/patient-details';
import { ProductLogComponent } from './product-log/product-log';
import { PharmacistDashboard } from './pharmacist-dashboard/pharmacist-dashboard';
import { PharmacyDispensary } from './pharmacy-dispensary/pharmacy-dispensary';
import { PharmPatients } from './pharm-patients/pharm-patients';
import { TransferLog } from './transfer-log/transfer-log';
import { ManualStockLog } from './manual-stock-log/manual-stock-log';
import { StoreInfo } from '../app/store-info/store-info';

export const appRouting = provideRouter([
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', loadComponent: () => import('./login/login').then(m => m.Login) },

  {
    path: 'admin',
    canActivate: [AuthGuard],
    data: { roles: ['admin'] },
    children: [
      { path: 'dashboard', component: AdminDashboard },
      { path: 'issue-drugs', component: IssueDrugComponent },
      { path: 'stores', component: Store },
      { path: 'wards', component: WardComponent },
      { path: 'stock-items', component: StockItemComponent },
      { path: 'transactions', component: TransactionsComponent },
      { path: 'patients', component: PatientsComponent },
      { path: 'logs', component: StaffLogsComponent },
      { path: 'reports', component: ReportComponent },
      { path: 'product-log', component: ProductLogComponent },
      { path: 'patients/:id', component: PatientDetailsComponent },
      { path: 'manual-stock-log', component: ManualStockLog },
      { path: 'store-info', component: StoreInfo }
    ]
  },

  {
    path: 'pharmacist',
    canActivate: [AuthGuard],
    data: { roles: ['pharmacist'] },
    children: [
      { path: 'dashboard', component: PharmacistDashboard },
      { path: 'dispensary', component: PharmacyDispensary },
      { path: 'patients', component: PharmPatients },
      { path: 'transfers', component: TransferLog }
    ]
  },

  { path: '**', redirectTo: '/login' }
]);
